/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import FolderSelector from 'file-browser/FolderSelector';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

class FolderSelectorView extends Backbone.View {
  static initClass() {
    this.prototype.events = {
      'change input[type=hidden]': 'renderComponent',
    };
  }

  initialize({initialFolderId, inputClassName, inputData, props}) {
    this.inputClassName = inputClassName;
    this.inputData = inputData;
    this.props = props;
    this.onChange = this.onChange.bind(this);
    this.folderId = initialFolderId;
    if (this.inputClassName == null) {
      this.inputClassName = 'folder-selector-view-input';
    }
    if (this.inputData == null) {
      this.inputData = null;
    }
    if (this.props == null) {
      this.props = {};
    }
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.$container[0]);
    return super.remove();
  }

  onChange(e) {
    this.$('input[type=hidden]').val(e.target.value).trigger('change');
  }

  renderComponent() {
    // Component expects null, not empty string.
    const value = this.$input.val() || null;
    // eslint-disable-next-line no-restricted-syntax
    const props = _.extend({}, this.props, {
      value,
      onChange: this.onChange,
    });
    if (props.unsetOnFetchFail == null) {
      props.unsetOnFetchFail = true;
    }
    renderToDOM(<FolderSelector {...props} />, this.$container[0]);
  }

  render() {
    this.$input = $('<input>')
      .attr({type: 'hidden', value: this.folderId})
      .addClass(this.inputClassName)
      .data(this.inputData);
    this.$container = $('<div>');
    this.renderComponent();
    this.$el.html(this.$input).append(this.$container);
    return this;
  }
}
FolderSelectorView.initClass();

export default FolderSelectorView;
